import React, {Fragment, useEffect, useState} from 'react';
import {editarClienteRating, eliminarCliente} from "../../redux/reducers/clientesReducer";
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    ListSubheader,
    Menu,
    MenuItem,
    Paper,
    Tab,
    Tabs,
    Theme,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import {
    Call,
    Close,
    EditOutlined,
    EmailOutlined,
    MapOutlined,
    NoteAddOutlined,
    PlagiarismOutlined,
    WhatsApp
} from '@mui/icons-material';
import LoadingProgress from "../../components/LoadingProgress";
import groupBy from 'lodash/groupBy';
import pdfSvg from '../../assets/img/pdf.svg';
import makeStyles from '@mui/styles/makeStyles';
import {useLocation, useNavigate} from "react-router-dom";
import Rating from "../../components/Rating";
import {formatDate, formatPeso, geoString, hasPermissionTo, PERSMISOS, translateText} from "../../helpers";
import {SlideTransition} from "../../components/transitions";
import ConfirmDialog from "../../components/ConfirmDialog";
import {SelectEnum, SelectPais} from "../../components/selects";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import Strings from "../../assets/strings";
import DefaultImgEmp from '../../assets/img/defaultAvatar_empresa.jpg';
import NoImg from '../../assets/img/defaultAvatar.jpg';
import {useCustomFormInput} from "../../hooks/useCustomFormInput";
import SelectUsoMultiples from "../../components/selects/SelectUsoMultiples";
import ClienteUsuario from "./ClienteUsuario";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {ICliente, IReferencia} from "../../redux/types/ICliente";
import {ConfCamposType} from "../../redux/types/ICompania";
import openAdjunto from "../../helpers/openAdjunto";

const useStyles = makeStyles((theme:Theme) => ({
    content: {
        padding: "0 !important",
    },
    contactForm: {
        "padding": "8px",
        paddingTop: 16,
        "position": "sticky",
        "bottom": "0",
        "left": "0",
        "width": "calc(100% - 16px)",
        "background": "white",
    },
    title: {
        flexGrow: 1,
        fontWeight: "normal",
    },
    imgCont: {
        width: 150,
        height: 150,
        borderRadius: "50%",
        overflow: "hidden",
        margin: "10px auto",
        "& img": {
            width: "100%",
        }
        // [theme.breakpoints.down('xs')]: {
        //     float:"left",
        //     width:50,
        //     height:50,
        //     marginRight: 12
        // },
    },
    nombre: {
        margin: 0,
        textAlign: "center",
    },
    header: {
        background: "#e6e6e6",
        padding: 10,
    },
    docs: {
        margin: 0,
        marginTop: 10,
        padding: 0,
        listStyle: "none",
        display: "flex",
        "& li": {
            width: 50,
            marginLeft: theme.spacing(2),

            "& img": {
                width: "100%",
            }
        }
    },
    ul: {
        margin: 0,
        marginTop: 10,
        padding: 0,
        listStyle: "none",
        columns: 2,
        "& li": {
            padding: "7px 15px",
            // -webkit-column-break-inside: avoid;
            // page-break-inside: avoid;
            breakInside: "avoid",

            "& h6": {
                fontWeight: "normal",
                margin: 0,
                fontSize: "0.8em",
            }
        },
        [theme.breakpoints.up('sm')]: {
            columns: 3,
        },

    },
    block: {
        borderTop: "1px solid #e6e6e6",
        padding: theme.spacing(2) + "px 0px",

        "& th": {
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
            paddingBottom: "0px !important",
            fontWeight: "normal",
        },
        "& tr": {
            height: 33,
            background: "transparent !important",
            "& a": {
                color: "inherit",
                textDecoration: "none",
            }
        },
        "& h4": {
            fontWeight: "normal",
            margin: "0",
            marginLeft: theme.spacing(2),
            color: theme.palette.secondary.main
        }
    },
    contactBtn:{
        position: "sticky",
        bottom: 0,
        padding: theme.spacing(1),
        zIndex: 1,
        background: "white",
        "& button":{
            background: theme.palette.grey[100] +" !important",
        }
    },
    dialogPaper:{
        height: "100%"
    }
}));

const initialState:ICliente = {
    estadoCivil: "",
    tipoVivienda: undefined,
    archivos: [],
    referencias: [],
    calificacion: undefined,
};
const TranLeft = SlideTransition("left");
export default function ContactDetails() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {pathname, state} = useLocation();
    const customFormInput = useCustomFormInput("cliente") as ConfCamposType;
     //   fulfilled: state.clientes.fulfilled,



    const {byId,status} = useAppSelector(state => state.clientes);

    const [tab, setTab] = useState(1);

    const [data, setData] = useState(initialState);
    const theme = useTheme();
    const smVewport = useMediaQuery(theme.breakpoints.down('md'));

    const [showMenu, setShowMenu] = useState(null);
    const [referencias, setReferencias] = useState<{[key:string]: IReferencia }>();

    const classes = useStyles();

    useEffect(() => {
        setTab(1);
        let refs = {};

        try {
            refs = groupBy(byId?.referencias, function (n) {
                return n.tipoString;
            });
        } catch (e) {
        }
        setReferencias(refs);
        setData({...byId});
    }, [setTab, setData, byId]);
    const close = () => {
        navigate(-1);
    };
    const TabPanel = (props:any) => {
        const {children, value, index, ...other} = props;

        return (
            <Box
                role="tabpanel"
                id={`tabpanel-${index}`}
                aria-labelledby={`tab-${index}`}
                p={1}
                display={value === index ? "block":"none"}
                {...other}
            >
                {value === index && <>{children}</>}
            </Box>
        );
    }
    const handleRateChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {value} = e.target;
        dispatch(editarClienteRating({
            id: data.id!,
            rate: parseFloat(value),
        }));
    };

    if(Boolean(!state?.cliente)) return null;

    return <>
        <Dialog
            open={true}
            maxWidth={"sm"}
            fullWidth={true}
            onClose={close}
            fullScreen={smVewport}
            classes={{paper:classes.dialogPaper}}
            // TransitionComponent={smVewport?TranLeft:undefined}
            {...(smVewport ? {TransitionComponent: TranLeft} : false)}

        >

            {(status === "loading") && <LoadingProgress/>}
            <TopBarDialog title={Strings.contacto} onClose={close}>
                {pathname.indexOf("prestamo") && //no mostra para evitar problema de goBack
                <Button size={"small"} sx={{mr:"4px"}}
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={(e:any) => setShowMenu(e.currentTarget)}
                            color="inherit"
                >
                    Opciones
                </Button>
                }

                <Menu
                    id="menu-appbar"
                    anchorEl={showMenu}
                    keepMounted
                    open={Boolean(showMenu)}
                    onClose={() => setShowMenu(null)}
                >
                    {hasPermissionTo(PERSMISOS.prestamosCrear) &&
                        <MenuItem onClick={() => {
                            setShowMenu(null);
                            navigate(`/crear/prestamo`, {replace:true, state:{ cliente: { clienteId: data.id, fullName: data.nombres + " " + data.apellidos }}});
                        }}>
                            <ListItemIcon>
                                <NoteAddOutlined fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>{Strings.crear} {Strings.prestamo}</ListItemText>
                        </MenuItem>
                    }
                    {data.estado !== 3 && hasPermissionTo(PERSMISOS.prestamos) &&
                        <MenuItem onClick={() => {
                            setShowMenu(null);
                            navigate(`/prestamos/${data.id}`, {replace:true});
                        }}>
                            <ListItemIcon>
                                <PlagiarismOutlined fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>{Strings.mostrar} {Strings.prestamos}</ListItemText>
                        </MenuItem>
                    }
                    {hasPermissionTo(PERSMISOS.clientesActualizar) &&
                        <MenuItem onClick={() => {
                            setShowMenu(null);
                            navigate(`/cliente/${data.id}`, {replace:true});
                        }}>
                            <ListItemIcon>
                                <EditOutlined fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>{Strings.editar}</ListItemText>
                        </MenuItem>
                    }
                    {hasPermissionTo(PERSMISOS.clientesEliminar) &&
                        <MenuItem onClick={() => {
                            setShowMenu(null);
                            navigate(pathname, {state:{...state, confirmDialog: true}});
                        }} sx={{color:"error.main"}}>
                            <ListItemIcon>
                                <Close sx={{color: "error.main"}} fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Eliminar</ListItemText>
                        </MenuItem>
                    }

                    {/*<MenuItem onClick={() => {*/}
                    {/*    setShowMenu(null);*/}
                    {/*    openNewWin("/reports/cliente/" + data.id);*/}
                    {/*    //downloadFiles({id: data.id},"cliente")*/}
                    {/*}}>{Strings.exportar}</MenuItem>*/}

                </Menu>
            </TopBarDialog>
            <DialogContent className={classes.content}>
                <header className={classes.header}>
                    <div className={classes.imgCont}>
                        <img
                            onClick={()=>openAdjunto(data.avatar ? data.avatar : (data.tipo === 2 ? DefaultImgEmp : NoImg))}
                            src={data.avatar ? data.avatar : (data.tipo === 2 ? DefaultImgEmp : NoImg)}
                             alt={data.nombres}
                        />
                    </div>
                    <h3 className={classes.nombre}>
                        {data.tipo === 2 ? (<>
                            {data.nombres} {data.apellidos} <br/>
                            <Typography variant={"body1"}>{data.razonSocial}</Typography>
                        </>) : (<>
                            {data.nombres} {data.apellidos}
                        </>)}
                    </h3>
                </header>
                {(data.condicionLaboral === 1 || Object.keys(data.referencias??{}).length > 0) &&
                <Tabs
                    value={tab}
                    onChange={(e, v) => setTab(v)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant={"fullWidth"}
                    aria-label="full width tabs example"
                >
                    <Tab label={Strings.datos} value={1}/>
                    {data.condicionLaboral === 1 && <Tab label={Strings.empleo} value={0}/>}
                    {Object.keys(data.referencias??{}).length > 0 && <Tab label={Strings.referencias} value={2}/>}

                </Tabs>
                }
                <TabPanel value={tab} index={1}>
                    <div>
                        <List>
                            {data.celular &&
                            <ListItem>
                                <ListItemText primary={data.celular} secondary={Strings.celular}/>
                                <ListItemSecondaryAction>
                                    {data?.celular?.startsWith("+") &&
                                    <a href={`https://wa.me/${data.celular?.replace(/[^+\d]+/g, "")}?text=${Strings.hola}, ${data.nombres} ${data.apellidos}. `}
                                       target={"_blank"} rel="noopener noreferrer">
                                        <IconButton edge="end" size="large">
                                            <WhatsApp/>
                                        </IconButton>
                                    </a>
                                    }
                                    <a href={"tel:" + data.celular}>
                                        <IconButton edge="end" size="large"><Call/></IconButton>
                                    </a>
                                </ListItemSecondaryAction>
                            </ListItem>
                            }
                            {data.telefono &&
                            <ListItem>
                                <ListItemText primary={data.telefono} secondary={Strings.telefono}/>
                                <ListItemSecondaryAction>
                                    <a href={"tel:" + data.telefono}>
                                        <IconButton edge="end" aria-label="delete" size="large">
                                            <Call/>
                                        </IconButton>
                                    </a>
                                </ListItemSecondaryAction>
                            </ListItem>
                            }

                            {data.email &&
                            <ListItem>
                                <ListItemText primary={data.email} secondary={Strings.email}/>
                                <ListItemSecondaryAction>
                                    <a href={"mailto:" + data.email}>
                                        <IconButton edge="end" size="large">
                                            <EmailOutlined/>
                                        </IconButton>
                                    </a>
                                </ListItemSecondaryAction>
                            </ListItem>
                            }
                            {!!data.direccion &&
                            <>
                                <Divider/>
                                <ListItem>
                                    <ListItemText
                                        primary={data.direccion + (data.direccion2 && data.direccion2.indexOf("http") === -1 ? " / " + data.direccion2 : "")}
                                        secondary={Strings.direccion}
                                    />
                                    {!!data.coordenadas &&
                                    <ListItemSecondaryAction>
                                        <a href={`https://www.google.com/maps?q=${data.coordenadas}&z=17`} target={"_blank"} rel="noopener noreferrer">
                                            <IconButton edge="end" size="large">
                                                <MapOutlined/>
                                            </IconButton>
                                        </a>
                                    </ListItemSecondaryAction>
                                    }

                                </ListItem>
                            </>
                            }
                            <Divider/>
                            <ListItem>
                                <Rating onChange={handleRateChange} name={"calificacion"}
                                        value={data.calificacion}/>
                            </ListItem>
                            <Divider/>
                            <ul className={classes.ul}>
                                {!!data.ingresos &&
                                <li>
                                    <span>{formatPeso(data.ingresos)}</span><h6>{Strings.ingresos}</h6>
                                </li>}
                                {!!data.condicionLaboral &&
                                <li>
                                    <span><SelectEnum group="condicionesLaboral" value={data.condicionLaboral}/></span>
                                    <h6>{Strings.condicionesLaboral}</h6>
                                </li>
                                }
                                {!!data.paisIdNacionalidad &&
                                <li>
                                    <span><SelectPais value={data.paisIdNacionalidad} display={"nacionalidad"}/></span>
                                    <h6>{Strings.nacionalidad}</h6>
                                </li>
                                }
                                {!!data.cedula &&
                                <li>
                                    <span>{data.cedula}</span>
                                    <h6>{data.tipo === 2 ? geoString("rnc", true) : Strings.cedula}</h6>
                                </li>
                                }
                                {!!data.faceBook &&
                                <li>
                                    <span>{data.faceBook}</span><h6>FaceBook</h6>
                                </li>
                                }
                                {!!data.instagram &&
                                <li>
                                    <span>{data.instagram}</span><h6>Instagram</h6>
                                </li>
                                }
                                {!!data.sexo &&
                                <li>
                                    <span> {data.sexo}</span><h6>{Strings.genero}</h6>
                                </li>
                                }
                                {!!data.estadoCivilId &&
                                <li>
                                    <span><SelectEnum group="estadosCivil" value={data.estadoCivilId}/></span>
                                    <h6>{Strings.estadoCivil}</h6>
                                </li>
                                }
                                {!!data.fechaNacimiento &&
                                <li>
                                    <span> {formatDate(data.fechaNacimiento)}</span>
                                    <h6>{Strings.fechaNacimiento}</h6>
                                </li>
                                }
                                {!!data.tipoVivienda &&
                                <li>
                                    <span> <SelectEnum group="tiposVivienda" value={data.tipoVivienda}/></span>
                                    <h6>{Strings.vivienda}</h6>
                                </li>
                                }
                                {!!data.ruta &&
                                <li>
                                    <span> {data.ruta}</span><h6>{Strings.ruta}</h6>
                                </li>
                                }
                                {customFormInput && Object.keys(customFormInput).map((key)=><Fragment key={key}>
                                    {(data as any)["campo"+key.slice(-1)] &&
                                    <ListItem>
                                        <ListItemText secondary={customFormInput[key].name}>
                                            {!!customFormInput[key].source?(
                                                <SelectUsoMultiples
                                                    group={customFormInput[key].source??""}
                                                    value={(data as any)["campo"+key.slice(-1)] ? (data as any)["campo"+key.slice(-1)] : undefined}
                                                />
                                            ):(
                                                (data as any)["campo"+key.slice(-1)]
                                            )}
                                        </ListItemText>
                                    </ListItem>
                                    }
                                </Fragment>)}
                            </ul>
                        </List>
                    </div>

                        {data.archivos && data.archivos?.length > 0 &&
                            <div className={"d-print-none " + classes.block}>
                                <h4>{Strings.documento}</h4>
                                <ul className={classes.docs}>
                                    {data.archivos.map((adj, i) =>
                                        <li key={i}>
                                            <img
                                                onClick={()=>adj.path && openAdjunto(adj.path!)}
                                                src={adj?.path?.includes(".pdf") ? pdfSvg : adj.path} alt=""/>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        }
                    {!!byId && <ClienteUsuario cliente={byId}/>}

                </TabPanel>
                <TabPanel value={tab} index={0}>
                    <List>
                        {data.trabajoTelefono &&
                        <ListItem>
                            <ListItemText primary={data.trabajoTelefono} secondary={Strings.telefono}/>
                            <ListItemSecondaryAction>
                                <a href={"tel:" + data.trabajoTelefono}>
                                    <IconButton edge="end" aria-label="delete" size="large">
                                        <Call/>
                                    </IconButton>
                                </a>
                            </ListItemSecondaryAction>
                        </ListItem>
                        }
                        {data.trabajoNombre &&
                        <ListItem>
                            <ListItemText primary={data.trabajoNombre} secondary={Strings.empresa}/>
                        </ListItem>
                        }
                        {data.trabajoPosicion &&
                        <ListItem>
                            <ListItemText primary={data.trabajoPosicion} secondary={Strings.posicion}/>
                        </ListItem>
                        }
                        {data.tiempoLaborando &&
                        <ListItem>
                            <ListItemText primary={data.tiempoLaborando}
                                          secondary={Strings.tiempoLaborando}/>
                        </ListItem>
                        }
                        {data.trabajoDireccion &&
                        <ListItem>
                            <ListItemText primary={data.trabajoDireccion} secondary={Strings.direccion}/>
                        </ListItem>
                        }
                    </List>
                </TabPanel>
                <TabPanel value={tab} index={2}>
                    <Paper elevation={0}>
                        {referencias && Object.keys(referencias).length > 0 && Object.keys(referencias).map((i) =>

                            <List dense key={i} subheader={
                                <ListSubheader color={"primary"}>
                                    {translateText((referencias[i] as IReferencia[])[0].tipoString)}
                                </ListSubheader>
                            }>

                                {(referencias[i] as IReferencia[]).map((r, i) =>
                                    <ListItem key={i}>
                                        <ListItemText primary={r.nombre}
                                                      secondary={
                                                          <>
                                                              {r.telefono} <br/>
                                                              {translateText(r.parentesco)}
                                                          </>
                                                      }
                                        />
                                        <ListItemSecondaryAction>
                                            <a href={"tel:" + r.telefono}>
                                                <IconButton edge="end" size="large"><Call/></IconButton>
                                            </a>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                )}
                            </List>
                        )}
                    </Paper>
                </TabPanel>

                {/*<Backdrop open={true} style={{    position: "absolute",zIndex: 0}}/>*/}
            </DialogContent>
        </Dialog>
        {pathname.indexOf("prestamo") === -1 && //no mostra para evitar problema eliminar pago en detalle de prestamos
            <ConfirmDialog onConfirm={() => dispatch(eliminarCliente(data.id!))}/>
        }
    </>;
}
